import { useState, useCallback } from "react";
import _ from "lodash";
import { getQueryStringValue, setQueryStringValue } from "../utils/queryString";

/**
 * Hook used to bind state to url params
 * (one way bining state => params)
 *
 * @param {string} defaultKey
 * @param {string} initialValue
 */

// initialValue [{client: 'asdasd', }]
function useQueryString(defaultKey, initialValue, { isMultiple, disableUrlParams }) {
    const urlParamValue = getQueryStringValue(defaultKey);

    if (isMultiple && urlParamValue) {
        Object.keys(urlParamValue).map((key, index) => {
            if (typeof urlParamValue[key] === "string") {
                urlParamValue[key] = urlParamValue[key].split(",");
            }

            return "";
        });
    }

    const [value, setValue] = useState(urlParamValue || initialValue);

    const onSetValue = useCallback(
        (newValue) => {
            setValue(newValue);

            if (disableUrlParams) {
                return;
            }

            if (isMultiple) {
                _.forEach(newValue, (value, key) => {
                    setQueryStringValue(`${defaultKey}[${key}]`, value.join(","));
                });
            } else {
                setQueryStringValue(defaultKey, newValue);
            }
        },
        [defaultKey, isMultiple]
    );

    return [value, onSetValue];
}

export default useQueryString;
